export const TYPES = {
  MESSAGE: 'MESSAGE',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}
